import BenefitAdjustmentCreatedEvent from '@/domains/payments/features/paymentModals/modals/adjustments/events/BenefitAdjustmentCreatedEvent';

export const BenefitAdjustmentEvents = {
  BenefitAdjustmentCreated: BenefitAdjustmentCreatedEvent,
};
